
const API_URL = 'https://api-5dvhxg2zwq-uc.a.run.app';
// const API_URL = 'http://localhost:5001/chatupweb/us-central1/api';
// const API_URL = 'https://113e-88-20-241-195.ngrok-free.app/chatupweb/us-central1/api';
const SEND_MESSAGE = `${API_URL}/chat/sendMessage`;
const SEND_MESSAGE_V2 = `${API_URL}/v2/chat/sendMessage`;
const GET_USER_CHAT_LIST = `${API_URL}/chat/getUserChatList`;
const DELETE_CHAT = `${API_URL}/chat/deleteChat`;
const UPDATE_CHAT_NAME = `${API_URL}/chat/updateChatName`;
const DELETE_CHAT_MESSAGE = `${API_URL}/chat/deleteChatMessage`;
const RESEND_CHAT_MESSAGE = `${API_URL}/chat/resendMessage`;
const RESEND_CHAT_MESSAGE_V2 = `${API_URL}/v2/chat/resendMessage`;
const RESEND_USER_MESSAGE_V2 = `${API_URL}/v2/chat/resendUserMessage`;
const REPLY_WITHOUT_PYTHON_V2 = `${API_URL}/v2/chat/replyWithoutPython`;
const UPLOAD_ATTACHMENT_V2 = `${API_URL}/v2/attachments/upload`;
const CANCEL_REQUEST = `${API_URL}/chat/cancelMessageRequest`;
const IMPROVE_PROMPT = `${API_URL}/chat/improvePrompt`;
const SPEECH_TO_TEXT = `${API_URL}/chat/speechToText`;
const GET_DEFAULT_PROMPTS = `${API_URL}/chat/defaultPrompts`;
const SET_SYSTEM_PROMPT = `${API_URL}/chat/setSystemPrompt`;
const SET_MESSAGE_MEMORY_LIMIT = `${API_URL}/chat/setMessageMemoryLimit`;
const GET_FILE_TEXT_LENGTH = `${API_URL}/chat/getFileTextLength`;
const REPORT_MESSAGE = `${API_URL}/chat/reportMessage`;
const CHECK_WEB_SEARCH_LIMIT = `${API_URL}/chat/checkWebSearchLimit`;
const CHAT_MIGRATION_CHECK = `${API_URL}/chat/migration/check`;
const CHAT_MIGRATION_CONVERT = `${API_URL}/chat/migration/convert`;

const IMAGE_AGENT = `${API_URL}/chat/image/sendMessage`;
const RESEND_IMAGE_MESSAGE = `${API_URL}/chat/image/resendMessage`;
const AUDIO_AGENT = `${API_URL}/chat/audio/sendMessage`;
const RESEND_AUDIO_MESSAGE = `${API_URL}/chat/audio/resendMessage`;

const CREATE_CHAT_FOLDER = `${API_URL}/folder/create`;
const EDIT_CHAT_FOLDER = `${API_URL}/folder/edit`;
const EDIT_PARENT_FOLDER = `${API_URL}/folder/editParent`;
const EDIT_FOLDER_CHAT_LIST = `${API_URL}/folder/editFolderChatList`;
const DELETE_CHAT_FOLDER = `${API_URL}/folder/delete`;

const STRIPE_GET_PAYMENT_LINK = `${API_URL}/stripe/getPaymentLink`;
const STRIPE_GET_BILLING_PORTAL_LINK = `${API_URL}/stripe/getBillingPortalLink`;
const STRIPE_GET_TRIAL_PAYMENT_LINK = `${API_URL}/stripe/getTrialPaymentLink`;
const STRIPE_CREATE_PAYMENT_LINK_FOR_RESET_COUNTER = `${API_URL}/stripe/createPaymentLinkForResetCounter`;
const STRIPE_CANCEL_SUBSCRIPTION = `${API_URL}/stripe/cancelSubscription`;
const STRIPE_UPGRADE_SUBSCRIPTION = `${API_URL}/stripe/upgradeSubscription`;
const STRIPE_REACTIVATE_SUBSCRIPTION = `${API_URL}/stripe/reactivateSubscription`;

const CANVA_SUGGEST_EDIT = `${API_URL}/canva/suggestEdit`;
const CANVA_ADD_FINISHING_TOUCHES = `${API_URL}/canva/addFinishingTouches`;
const CANVA_MODIFY_LENGTH = `${API_URL}/canva/modifyLength`;
const CANVA_MODIFY_READING_LEVEL = `${API_URL}/canva/modifyReadingLevel`;
const CANVA_TRANSLATE = `${API_URL}/canva/translate`;
const CANVA_GET_INTERESTING_FACT = `${API_URL}/canva/interestingFact`;
const CANVA_EDIT_TITLE = `${API_URL}/canva/editTitle`;

// Deep Research endpoints
const DEEP_RESEARCH_ASK_DETAILS = `${API_URL}/deepresearch/askDetails`;
const DEEP_RESEARCH_START = `${API_URL}/deepresearch/start`;
const DEEP_RESEARCH_CHECK_LIMITS = `${API_URL}/deepresearch/checkLimits`;
const DEEP_RESEARCH_EXPORT_PDF = `${API_URL}/deepresearch/exportPDF`;

const VERIFY_EMAIL = `${API_URL}/verify/email`;

const WHATSAPP_OTP_SEND = `${API_URL}/whatsapp/otp/send`;
const WHATSAPP_OTP_VERIFY = `${API_URL}/whatsapp/otp/verify`;

const CONTACT_FORM = `${API_URL}/contact/form`;
const CONTACT_SUBSCRIPTION_BUG_TICKET = `${API_URL}/contact/subscription-bug-ticket`;

const USER_SET_CID = `${API_URL}/user/setCID`;
const USER_SET_REF = `${API_URL}/user/setRef`;
const USER_SET_EID = `${API_URL}/user/setEID`;
const USER_SET_TTCLID = `${API_URL}/user/setTTCLID`;
const USER_SET_FBCLID = `${API_URL}/user/setFBCLID`;
const USER_HIDE_OFFER_POPUP = `${API_URL}/user/setHideOfferPopup`;
const USER_SET_HAS_SEEN_MODEL_WARNING = `${API_URL}/user/setHideModelWarning`;
const USER_HIDE_THUNDER_ATTACHMENT_WARNING = `${API_URL}/user/setHideThunderAttachmentWarning`;
const UPDATE_SCORE = `${API_URL}/user/updateUserScore`;
const UPDATE_MOBILE_INFO = `${API_URL}/user/updateMobileInfo`;
const USER_SET_TO_BE_DELETED = `${API_URL}/user/updateUserToBeDeleted`;
const RUN_CHECK_USER_DELETION = `${API_URL}/user/checkAndCancelUserDeletion`;
const USER_SET_LANGUAGE = `${API_URL}/user/setLanguage`;
const USER_GET_CUSTOM_TOKEN = `/crossLogin/customTokenGenerator`;
const USER_LOGOUT = `/crossLogin/logoutUser`;

const DOCUMENT_GET_CONTENT = `${API_URL}/document/getContent`;
const DOCUMENT_UPDATE_CONTENT = `${API_URL}/document/updateContent`;
const DOCUMENT_GET_DOCX = `${API_URL}/document/getDocx`;
const DOCUMENT_GET_PDF = `${API_URL}/document/getPdf`;

const MOBILE_GPLAY_VERIFY_PURCHASE = `${API_URL}/mobile/gplay/verifyPurchase`;
const MOBILE_GPLAY_VERIFY_TOKEN_RESET_PURCHASE = `${API_URL}/mobile/gplay/verifyResetTokenPurchase`;
const MOBILE_GPLAY_ADD_PURCHASE_ERROR = `${API_URL}/mobile/gplay/addGPlayPurchaseError`;

const MOBILE_APPLE_VERIFY_PURCHASE = `${API_URL}/mobile/apple/verifyPurchase`;

module.exports = {
    SEND_MESSAGE, GET_USER_CHAT_LIST, DELETE_CHAT, UPDATE_CHAT_NAME, CANCEL_REQUEST,
    DELETE_CHAT_MESSAGE, RESEND_CHAT_MESSAGE, STRIPE_GET_PAYMENT_LINK, STRIPE_GET_BILLING_PORTAL_LINK, STRIPE_GET_TRIAL_PAYMENT_LINK,
    VERIFY_EMAIL,
    WHATSAPP_OTP_SEND, WHATSAPP_OTP_VERIFY,
    CONTACT_FORM, CONTACT_SUBSCRIPTION_BUG_TICKET, USER_SET_CID, CREATE_CHAT_FOLDER, EDIT_CHAT_FOLDER, EDIT_PARENT_FOLDER, EDIT_FOLDER_CHAT_LIST, SET_SYSTEM_PROMPT,
    DELETE_CHAT_FOLDER, USER_SET_EID, IMPROVE_PROMPT, SPEECH_TO_TEXT,
    GET_DEFAULT_PROMPTS,
    USER_SET_REF, SET_MESSAGE_MEMORY_LIMIT, CANVA_ADD_FINISHING_TOUCHES, CANVA_MODIFY_LENGTH, CANVA_MODIFY_READING_LEVEL,
    CANVA_TRANSLATE, CANVA_SUGGEST_EDIT, CANVA_EDIT_TITLE, USER_SET_TTCLID, CANVA_GET_INTERESTING_FACT, DOCUMENT_GET_CONTENT,
    DOCUMENT_UPDATE_CONTENT, GET_FILE_TEXT_LENGTH, USER_HIDE_OFFER_POPUP, USER_SET_HAS_SEEN_MODEL_WARNING, USER_HIDE_THUNDER_ATTACHMENT_WARNING,
    STRIPE_CREATE_PAYMENT_LINK_FOR_RESET_COUNTER, STRIPE_CANCEL_SUBSCRIPTION, STRIPE_UPGRADE_SUBSCRIPTION, STRIPE_REACTIVATE_SUBSCRIPTION,
    DEEP_RESEARCH_ASK_DETAILS, DEEP_RESEARCH_START, DEEP_RESEARCH_CHECK_LIMITS, DEEP_RESEARCH_EXPORT_PDF,
    UPDATE_SCORE, DOCUMENT_GET_DOCX, DOCUMENT_GET_PDF, UPDATE_MOBILE_INFO, MOBILE_GPLAY_VERIFY_PURCHASE,
    MOBILE_GPLAY_VERIFY_TOKEN_RESET_PURCHASE, MOBILE_APPLE_VERIFY_PURCHASE, USER_SET_FBCLID, REPORT_MESSAGE,
    USER_SET_TO_BE_DELETED, RUN_CHECK_USER_DELETION, CHECK_WEB_SEARCH_LIMIT, MOBILE_GPLAY_ADD_PURCHASE_ERROR, IMAGE_AGENT, RESEND_IMAGE_MESSAGE,
    AUDIO_AGENT, RESEND_AUDIO_MESSAGE, USER_GET_CUSTOM_TOKEN, USER_LOGOUT, USER_SET_LANGUAGE, SEND_MESSAGE_V2, RESEND_CHAT_MESSAGE_V2,
    RESEND_USER_MESSAGE_V2, REPLY_WITHOUT_PYTHON_V2, UPLOAD_ATTACHMENT_V2,
    CHAT_MIGRATION_CHECK, CHAT_MIGRATION_CONVERT
};
